export function ExitIcon({ color }: { color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 32 32"
    >
      <g fill={color} clipPath="url(#clip0_1_2)"  >
        <path d="M12.37 31.05c-.15-.11-.34-.1-.51-.15-1.65-.48-2.79-1.95-2.8-3.69-.02-2.15-.01-4.3 0-6.46 0-.78.56-1.35 1.3-1.35.75 0 1.29.58 1.29 1.38v6.21c0 .95.51 1.45 1.46 1.45h13.88c.97 0 1.46-.5 1.46-1.48V4.04c0-.98-.49-1.47-1.47-1.47H13.13c-.99 0-1.48.5-1.48 1.49v6.25c0 .61-.37 1.1-.94 1.26-.56.16-1.14-.06-1.45-.56-.14-.23-.2-.48-.2-.75 0-2.14-.02-4.28 0-6.43C9.09 1.67 10.8 0 12.98 0h14.1c2.03 0 3.58 1.31 3.92 3.33 0 .02.03.05.05.07v24.37c-.21 1.42-1 2.39-2.27 3.01-.36.18-.75.21-1.13.26H12.37v.01z" />
        <path d="M4.46 16.89c.55.54 1.11 1.08 1.66 1.64.37.38.47.84.29 1.34-.19.5-.56.78-1.09.84-.38.04-.73-.07-1-.34C3 19.06 1.68 17.75.38 16.42c-.51-.52-.5-1.28 0-1.8 1.29-1.31 2.59-2.61 3.9-3.9.51-.5 1.3-.48 1.8 0 .51.5.52 1.3.01 1.82-.53.55-1.09 1.08-1.65 1.64.13.07.24.05.34.05h15.76c.81 0 1.33.41 1.43 1.14.1.68-.42 1.35-1.1 1.43-.14.02-.28.01-.42.01H4.49s-.02.05-.04.07l.01.01z" />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <path fill={color} d="M0 0H31.05V31.05H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}